import React, { useRef } from 'react';
import { StyledInput, StyledInputContainer, StyledLabel } from './style';
import { SpaceProps } from 'styled-system';

type InputWithLabelType = SpaceProps & {
  label: string;
  value?: string;
  onChange?: (element) => void;
  id: string;
  type?: string;
};

const InputWithLabel: React.FC<InputWithLabelType> = ({
  label,
  value,
  onChange,
  id,
  type = 'text',
  ...rest
}) => {
  const inputRef = useRef(null);

  return (
    <StyledInputContainer {...rest} onClick={() => inputRef.current.focus()}>
      <StyledLabel htmlFor={id}>{label}</StyledLabel>
      <StyledInput
        ref={inputRef}
        value={value}
        onChange={onChange}
        id={id}
        type={type}
      />
    </StyledInputContainer>
  );
};

export default InputWithLabel;
